const Logo = ({ className = "", size = "default", showText = false }) => {
  const sizes = {
    small: { icon: "h-20" },
    default: { icon: "h-32" },
    large: { icon: "h-40" }
  };

  const currentSize = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center ${className}`}>
      {/* Logo Image - Kiwi Bird with NZ Flag and Silver Fern */}
      <img 
        src="https://customer-assets.emergentagent.com/job_85319587-e4ee-4a62-aecb-a60ff1e5f34f/artifacts/rjbabvt5_image.png"
        alt="Kiwi Connect Consultants Logo"
        className={`${currentSize.icon} object-contain`}
      />
    </div>
  );
};

export default Logo;
